/**
 * Staff roles on a Company membership.
 * Platform admins are not memberships — they use `User.isPlatformAdmin`.
 * Borrowers are not memberships — they use loan participation (later).
 */
import { isOneOf } from '../helpers/is-one-of.js'
export const COMPANY_ROLES = [
  'LENDER_USER',
  'ORIGINATOR_RMLO',
  'ORIGINATOR_CLERICAL',
] as const

export type CompanyRole = (typeof COMPANY_ROLES)[number]

/** Display labels for {@link CompanyRole}. Exhaustive so a new role fails the build. */
export const COMPANY_ROLE_LABELS: Record<CompanyRole, string> = {
  LENDER_USER: 'Lender user',
  ORIGINATOR_RMLO: 'Originator RMLO',
  ORIGINATOR_CLERICAL: 'Originator clerical',
}

export function isCompanyRole(value: string): value is CompanyRole {
  return isOneOf(value, COMPANY_ROLES)
}
